import { Component, ChangeDetectionStrategy, inject, OnDestroy, Signal, computed } from '@angular/core';
import * as Models from '../../_shared/models/models-index';
import { Store } from '@ngrx/store';
import { map, Observable, tap, filter, switchMap } from 'rxjs';
import { ReportViewActions, ReportViewSelectors, ReportViewsState } from '../../_shared/report-view/store';
import { AppState } from '../../_store/app-state.model';
import { AppSelectors } from '../../_store/selector-types';

@Component({
    selector: 'layout-perspective-selector',
    templateUrl: './perspective-selector.component.html',
    styleUrls: ['./perspective-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PerspectiveSelectorComponent implements OnDestroy {
  private reportName: string;
  constructor(
    private store$: Store<ReportViewsState>
  ) { }

  vm$: Observable<{ selected: Models.ReportViewPerspective, selectedName: string, perspectives: Models.ReportViewPerspective[] }>;
  ngOnInit() {
    this.vm$ = this.store$.select(AppSelectors.selectCurrentRouteData).pipe(
      switchMap(routeData => this.store$.select(ReportViewSelectors.selectReportView({ reportName: routeData.reportName }))),
      // tap(current => console.log('current perspectives', current)),
      filter(current => !!current?.perspectives),
      tap(current => this.reportName = current.reportName),
      map(perspectives => {
        const selected = perspectives.selectedPerspective;
        const selectedName = selected ? selected.name : '';
        return { selected, selectedName, perspectives: perspectives.perspectives };
      })
    )
  }


  ngOnDestroy() {
    
  }

  selectedPerspectiveChanged(perspective: Models.ReportViewPerspective) {
    this.store$.dispatch(ReportViewActions.selectPerspective({reportName: this.reportName, perspective }));
  }
}